import './ErrorPage.scss';
import { useParams } from 'react-router';
import Header from '../../components/Header/Header';
import TwoColumnLayout from '../../components/TwoColumnLayout/TwoColumnLayout';
import NotFoundErrorPageSide from './ErrorPageSide/NotFoundErrorPageSide';
import ErrorPageSide from './ErrorPageSide/ErrorPageSide';
import NotFoundErrorPageBody from './ErrorPageBody/NotFoundErrorPageBody';
import LoadingErrorPageBody from './ErrorPageBody/LoadingErrorPageBody';
import SubmitErrorPageBody from './ErrorPageBody/SubmitErrorPageBody';
import RetrievalErrorPageBody from './ErrorPageBody/RetrievalErrorPageBody';
import { useAppDispatch } from '../../store/hooks';
import { useEffect } from 'react';
import { setCurrentStep } from '../../store/commonSlice';

function ErrorPage(): JSX.Element {
  const dispatch = useAppDispatch();
  const { errorType } = useParams() as {
    errorType: string;
  };

  useEffect(() => {
    dispatch(setCurrentStep('Error'));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Header>
        {((): JSX.Element => {
          switch (errorType) {
            case '404':
              return <>404 error</>;
            case 'retrieval-error':
              return <>Retrieval error</>;
            case 'submit-error':
              return <>Submit error</>;
            case 'loading-error':
            default:
              return <>Oops</>;
          }
        })()}
      </Header>

      <main className='error-page'>
        <TwoColumnLayout
          rightColumn={((): JSX.Element => {
            switch (errorType) {
              case '404':
                return <NotFoundErrorPageSide />;
              case 'retrieval-error':
              case 'submit-error':
              case 'loading-error':
              default:
                return <ErrorPageSide />;
            }
          })()}
        >
          {((): JSX.Element => {
            switch (errorType) {
              case '404':
                return <NotFoundErrorPageBody />;
              case 'retrieval-error':
                return <RetrievalErrorPageBody />;
              case 'submit-error':
                return <SubmitErrorPageBody />;
              case 'loading-error':
              default:
                return <LoadingErrorPageBody />;
            }
          })()}
        </TwoColumnLayout>
      </main>
    </>
  );
}

export default ErrorPage;
